import React from 'react';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';
import ReactAsyncSelect from 'react-select/async';
import classNames from 'classnames';
import { useTheme } from '@vectord/styles';

import styles from './Select.module.scss';

const selectType = {
  async: ReactAsyncSelect,
  default: ReactSelect,
};

export default function Select({
  type = 'default',
  className,
  compact = false,
  styles: selectStyles,
  ...remainingProps
}) {
  const Component = selectType[type];
  const theme = useTheme();

  const _styles = {
    control: (styles, state) => ({
      ...styles,
      padding: compact ? 0 : theme.spacing.xxs,
      borderWidth: compact ? 0 : '0.2rem',
      boxShadow: 'none',
      color: state.isDisabled && theme.palette.fontColor.disabled,
      backgroundColor:
        state.isDisabled &&
        !compact &&
        theme.palette.backgroundColor.disabledBackground,
      minHeight: compact ? '2.5rem' : '3.2rem',
      borderColor: state.isFocused
        ? theme.palette.primaryColor['60']
        : theme.palette.borderColor,
      '&:hover': {
        borderColor: state.isFocused
          ? theme.palette.primaryColor['60']
          : theme.palette.borderColor,
      },
    }),
    singleValue: (styles, state) => ({
      ...styles,
      color: state.isDisabled && theme.palette.fontColor.disabled,
      marginLeft: compact ? 0 : '0.2rem',
      marginRight: compact ? 0 : '0.2rem',
    }),
    indicatorSeparator: (styles) => ({
      ...styles,
      display: 'none',
    }),
    input: (styles) => ({
      ...styles,
      margin: compact ? 0 : '0.2rem',
      paddingTop: compact ? 0 : '0.2rem',
      paddingBottom: compact ? 0 : '0.2rem',
    }),
    dropdownIndicator: (styles) => ({
      ...styles,
      padding: compact ? 0 : theme.spacing.xxs,
    }),
    clearIndicator: (styles) => ({
      ...styles,
      padding: compact ? 0 : theme.spacing.xxs,
    }),
    valueContainer: (styles) => ({
      ...styles,
      padding: compact ? '0 0.4rem' : '0.2rem 0.8rem',
    }),
    placeholder: (styles) => ({
      ...styles,
      marginLeft: compact ? 0 : '0.2rem',
      marginRight: compact ? 0 : '0.2rem',
    }),
    ...selectStyles,
  };

  return (
    <Component
      className={classNames(styles.root, className)}
      styles={_styles}
      {...remainingProps}
    />
  );
}

Select.propTypes = {
  type: PropTypes.oneOf(Object.keys(selectType)),
  className: PropTypes.string,
  compact: PropTypes.bool,
  styles: PropTypes.object,
};
